import { buildDocumentationMenuItems } from '../DocumentationMenuItems';
import { DOCUMENTATION } from '../../constants/docLinks';
// Builds the tooltip text for a selection-dependent button. `actionLabel` is the
// bare action phrase ("delete", "add tags"); `actionConnector` is an optional
// word ("to", "for") used only in the selected-count sentence, since not every
// verb needs one ("Delete 3 selected sources" vs "Add tags to 3 selected sources").
const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const getButtonTooltip = (selectedCount, actionLabel = '', resourceNouns = {}, actionConnector = '') => {
    const { selectNoun = '', countNoun = '' } = resourceNouns;
    if (selectedCount === 0) {
        return `Select ${selectNoun} to ${actionLabel}`;
    }
    const connector = actionConnector ? ` ${actionConnector}` : '';
    const plural = selectedCount > 1 ? 's' : '';
    return `${capitalize(actionLabel)}${connector} ${selectedCount} selected ${countNoun}${plural}`;
};
// Resolves disabled/tooltip state for a TopBar button config array based on the
// current selection count
export const applyButtonState = (config, selectedCount, resourceNouns, { defaultSelectionDependent = false } = {}) =>
    config.map(({ selectionDependent = defaultSelectionDependent, actionLabel, actionConnector, ...buttonConfig }) => ({
        ...buttonConfig,
        disabled: selectionDependent && selectedCount === 0,
        tooltip: selectionDependent
            ? getButtonTooltip(selectedCount, actionLabel, resourceNouns, actionConnector)
            : undefined,
    }));
// Single documentation-links overflow menu item, shared by every TopBar consumer.
export const getDocumentationDropDownMenuItems = (documentationType) => [
    {
        key: `${documentationType}-documentation`,
        label: DOCUMENTATION[documentationType]?.buttonText,
        className: 'rm-top-bar-submenu-item',
        popupClassName: 'rm-top-bar-submenu-popup',
        children: buildDocumentationMenuItems(documentationType),
    },
];
